
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ambassador-alternative",
      function () {
        return require("private-next-pages/ambassador-alternative.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ambassador-alternative"])
      });
    }
  